import { render, staticRenderFns } from "./SignContract.vue?vue&type=template&id=0b35c853"
import script from "./SignContract.vue?vue&type=script&lang=js"
export * from "./SignContract.vue?vue&type=script&lang=js"
import style0 from "./SignContract.vue?vue&type=style&index=0&id=0b35c853&prod&lang=scss"
import style1 from "./SignContract.vue?vue&type=style&index=1&id=0b35c853&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports